<template>
  <div class="land-list-wrapper" ref="listWrapper" v-loading="loading">
    <div class="land-list">
      <land-card
        v-for="item in showLandList"
        :key="item.id"
        :info="item"
        @click.native="handleClickLand(item)"
      ></land-card>
    </div>
    <div class="no-land-data" v-if="!loading && showLandList.length == 0">
      <img src="@/assets/images/insure/no-land-data.png" alt="" />
      <p>暂无可选地块</p>
    </div>
  </div>
</template>

<script>
import LandCard from "./LandCard";
import initBScroll from "@/utils/bScroll";
import { mapGetters, mapState } from "vuex";
export default {
  name: "ListMode",
  components: { LandCard },
  data() {
    return {
      scroll: null,
      landNowSelectList: [],
    };
  },
  computed: {
    ...mapGetters("damage", {
      showLandList: "showLandList",
      hadSelectedLandList: "hadSelectedLandList",
    }),
    ...mapState("damage", {
      loading: "landLoading",
      currentMode: "showLandMode",
    }),
  },
  watch: {
    currentMode(val) {
      if (val == "ListMode") {
        this.$nextTick(() => {
          console.log("刷新");
          this.refreshScroll();
        });
      }
    },
  },
  mounted() {
    this.scroll = initBScroll(this.$refs.listWrapper);
  },

  methods: {
    // 点击地块
    handleClickLand(item) {
      if (item.selectableFlag) {
        return;
      }
      this.$store.commit("damage/changeSelectStatus", item.id);
    },
    refreshScroll() {
      this.scroll && this.scroll.refresh();
    },
  },
};
</script>

<style lang="scss" scoped>
.land-list-wrapper {
  position: relative;
  //  height: calc(100% - 110px);
  height: 100%;
  overflow: hidden;
  padding: 0 15px;
  .land-list {
    display: flex;
    flex-wrap: wrap;
    padding: 15px 15px 0px 15px;
  }
  ::v-deep .bscroll-vertical-scrollbar {
    z-index: 20 !important;
    .bscroll-indicator {
      background: #dcdfe6 !important;
    }
  }

  .no-land-data {
    padding-top: 228px;
    img {
      display: block;
      width: 151px;
      height: 115px;
      margin: 0 auto;
    }
    p {
      font-size: 16px;
      line-height: 22px;
      color: #333333;
      text-align: center;
      margin-top: 24px;
    }
  }
}
</style>
